import ufeApi from 'services/api/ufeApi';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+BI+Digital+Card+Number+API

function getBiDigitalCardNumber(userProfileId) {
    const url = `/gway/v2/bi/profiles/${userProfileId}/digitalCardNumber?source=other`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default getBiDigitalCardNumber;
